module.exports = __webpack_public_path__ + "img/IMG_7189_L_Foamcore_MockedUp.48f72108.jpg";